<mm-account-info-header
[accountInfo]="accountInfo"
(refresh)="refresh($event)"
></mm-account-info-header>
<mm-sa-master-status-table [ngClass]="(createRequestStep$ | async) === 'view-msv' ? 'hide-table' : ''"></mm-sa-master-status-table>
